import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import "./AllReview.css";
import BlackStar from "../../../../assets/images/onboardingImages/BlackStar.svg";
import HalfStar from "../../../../assets/images/onboardingImages/HalfStar.svg";
import AngleDown from "../../../../assets/images/dropdownAngle.svg";
import longArrow from "../../../../assets/images/onboardingImages/longArrow.svg";
import { useParams, useNavigate } from "react-router-dom";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import { globalCommunity } from "../../../../store/globalstore";
import { useAtom } from "jotai";

const AllReview = () => {
  const [communityFromStore] = useAtom(globalCommunity);

  const [show, setShow] = useState(true);
  const [reviews, setReviewRes] = useState([]);
  const { communityId } = useParams();
  const api = useApi();
  const navigate = useNavigate();

  const handleClose = () => setShow(false);
  const [showReviewIndex, setShowReviewIndex] = useState(null);

  const [showReview, setShowReview] = useState(false);

  // const toggleReview = () => {
  //   setShowReview((prev) => !prev);
  // };

  const getPublicCommunityReviews = async () => {
    try {
      const response = await api(
        "post",
        "communityReview/getPublicCommunityReviews",
        {
          communityId: communityId,
        }
      );

      if (response?.status) {
        setReviewRes(response?.data?.reviews || []);
      }
    } catch (error) {
      console.error("🚀 -> getCommunity -> error:", error);
    } finally {
    }
  };

  useEffect(() => {
    if (communityId) {
      getPublicCommunityReviews();
    }
  }, [communityId]);

  const toggleReview = (index) => {
    setShowReviewIndex((prev) => (prev === index ? null : index));
  };

  return (
    <>
      <div className="onboarding-modal-wrapper">
        <Modal
          animation={false}
          show={show}
          onHide={handleClose}
          centered
          dialogClassName="custom-onboarding-modal cmSide reviewModal reviewAll"
          backdropClassName="onboarding-custom-backdrop"
        >
          <Modal.Body className="bg-white figma-drop-shadow">
            <button className="reverseArrow" type="button">
              <img
                alt=""
                src={longArrow}
                onClick={() => {
                  navigate(`/community/${communityFromStore?.name}`, {
                    replace: true,
                  });
                }}
              />
            </button>
            <div className="onboardingContentBox top31px">
              <div className="businessName">
                {communityFromStore?.disPlayName}
              </div>
              <h2 className="title">
                <span>Reviews</span>
              </h2>
              <p className="desc">All verifiable on the blockchain</p>

              {reviews?.map((item, index) => {
                // const maskedEmail = item.email.replace(/(.{2}).+(@.+)/, "$1*****$2");
                const joinDate = new Date(item.joinDate).toLocaleDateString(
                  "en-GB"
                );
                const stars = Math.floor(item.rating);
                const hasHalfStar = item.rating % 1 !== 0;

                return (
                  <div className="ReviewItem" key={item._id}>
                    <div className="row">
                      <div className="col-6">
                        <div className="emailBox">
                          <p className="title">Email:</p>
                          <p className="desc d-flex align-items-center gap-1" ><span>{item.email.slice(0,3)}</span><span className="mt-1">{`********`}</span> <span>.com</span></p>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="ratingBox">
                          <p className="title">Rating:</p>
                          <p className="starBox">
                            {[...Array(stars)].map((_, i) => (
                              <img key={i} src={BlackStar} alt="Star" />
                            ))}
                            {hasHalfStar && (
                              <img src={HalfStar} alt="Half Star" />
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-3">
                        <div className="joinedBox">
                          <p className="title">Joined</p>
                          <p className="desc">{joinDate}</p>
                        </div>
                      </div>
                      <div className="col-3">
                        <div className="tierBox">
                          <p className="title">Tier</p>
                          <p className="desc">Unlimited</p>{" "}
                          {/* Adjust if dynamic */}
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="ReviewBtnBox">
                          <button onClick={() => toggleReview(index)}>
                            Read Review
                            <img
                              src={AngleDown}
                              alt="AngleDown"
                              className={
                                showReviewIndex === index ? "rotate-icon" : ""
                              }
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                    {showReviewIndex === index && (
                      <div className="row">
                        <div className="col-12">
                          <div className="reviewText">
                            <p>{item.comment}</p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default AllReview;
